import { createApp } from "vue";
import { createPinia } from "pinia";

import App from "./App.vue";
import router from "./router";

import * as Sentry from "@sentry/vue";

import Button from "@/components/Button.vue";
import Card from "@/components/Card.vue";
import LoadingOverlay from "@/components/loading/LoadingOverlay.vue";
import Label from "@/components/Label.vue";

import "gitart-vue-dialog/dist/style.css";
import { GDialog, plugin as dialogPlugin } from "gitart-vue-dialog";

import Paginate from "vuejs-paginate-next";

import { VTooltip, VClosePopper, Dropdown, Tooltip } from "floating-vue";
import "floating-vue/dist/style.css";

import Toast from "vue-toastification";
import type { PluginOptions } from "vue-toastification";
import "vue-toastification/dist/index.css";

import VueConfetti from "vue-confetti";

import "./assets/main.css";

import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import "./icons";

import clickOutside from "@/directives/click-outside";
import Maska from "maska";

import { VueQueryPlugin } from "@tanstack/vue-query";

const app = createApp(App);

app.component("Button", Button);
app.component("Card", Card);
app.component("Label", Label);
app.component("GDialog", GDialog);
app.component("LoadingOverlay", LoadingOverlay);
app.component("font-awesome-icon", FontAwesomeIcon);
app.component("Paginate", Paginate);
app.component("VDropdown", Dropdown);
app.component("VTooltip", Tooltip);

app.use(createPinia());
app.use(router);
app.use(dialogPlugin);
app.use(Maska);
app.use(VueQueryPlugin);
const toastOptions: PluginOptions = {};
app.use(Toast, toastOptions);

app.use(VueConfetti);

app.directive("click-outside", clickOutside);
app.directive("tooltip", VTooltip);
app.directive("close-popper", VClosePopper);

app.provide("$dialog", app.config.globalProperties.$dialog);
app.provide("$confetti", app.config.globalProperties.$confetti);

if (import.meta.env.VITE_APP_ENV === "production") {
  Sentry.init({
    app,
    dsn: "https://9aa829fb6cc54d06be995e4cdb73efde@o4504800974929920.ingest.sentry.io/4504800978206720",
    // integrations: [
    //   new BrowserTracing({
    //     routingInstrumentation: Sentry.vueRouterInstrumentation(router),
    //     // tracePropagationTargets: ["localhost", "my-site-url.com", /^\//],
    //   }),
    // ],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 0.8,
    environment: import.meta.env.VITE_APP_ENV || "production",
  });
}

app.mount("#app");
